<template>
<div>
<CCardGroup class="" v-if="isHideDetails">
      <CCard        class="header-bg"        
      >
<div class="row mx-0">
        <cHotelThumbnail   v-if="hotelObj" :imgURL='hotelObj.mainImageUrl'>
        
         </cHotelThumbnail>
         <div class="col-5">
<h4 class="px-3 py-2 text-white">{{hotel.hotelName}}</h4>
             <cStatusButton v-if="hotelObj&&isNeedStatusBtn&&showStatus"
                    class="generate-ex-btn label-margin-unset float-left"
                    :isConfirm="true"
                    :buttonDesc="'Are you sure you want to update the status?'"
                    :defaultStatus.sync="hotelObj.isActive"
                    @change="onChangeHotelStatus"
                    :label="{checked: $t('createHotel.active'), unchecked: $t('createHotel.inactive')}"
                  ></cStatusButton>
         </div>
         <div class="col-3"></div>
         <cHotelSelection class="col-3 py-3" v-if="toShowDp" :selValue="hotelObj" @getSelHotel="emitSelHotelObj"/>
         
         <TheHeaderDropdownAccnt class="py-3" v-if="isHmsFlow" style="list-style: none;"/>
          </div>
         
            <CCardFooter  class="px-3 py-2" @click="toggleCollapse">
              <CLink
                class="font-weight-bold font-xs text-muted d-flex justify-content-between"                
                target="_blank"
              >
                {{collapse?'Hide details':'View details'}} 
                <CIcon v-if="!collapse" name="cil-chevron-bottom" width="16"/>
                <CIcon v-else name="cil-chevron-top" width="16"/>
              </CLink>
            </CCardFooter>
          
      </CCard>

      

    </CCardGroup>


  <CCollapse :show="collapse">
    <CCard>
    <div class='row' >
    <CCardBody class='max-w-200 thumbnail' v-if="isShowLeftPart" >
    <!-- <CRow > -->
        
             <!-- <strong class="c-gray">{{hotel.hotelid}}</strong> -->
             
     
        <!-- <div>     
             <span class="c-lightgray">{{hotel.supplierName}}</span>
             
        </div> -->
     
    <!-- </CRow> -->
    
    <!-- <CRow>
      <CCol>
          <img :src="hmsDefaultHotelImg" width="120px" height="120px" />
      <h3>{{hotel.hotelName}}</h3>

      </CCol>
    </CRow> -->
     <div class="">
          <cHotelThumbnail class="post-content responsive"   v-if="hotelObj" :imgURL='hotelObj.mainImageUrl'>
        
         </cHotelThumbnail>
         

      <div  class="caption post-content text-center">   
        <h4 class="px-3 py-2">{{hotel.hotelName}}</h4> 
<span class="c-lightgray">({{hotel.hotelid}})</span>
<p >{{hotel.www}}</p>  
             <!-- <span class="c-lightgray" v-if="hotel.supplierName">{{hotel.supplierName}}</span> -->
             <span   v-if="hotel.supplierGroup&&hotel.supplierGroup.name">{{hotel.supplierGroup.name}}</span>

             
        </div>
     
     </div>
     
        
    </CCardBody>
    <div></div>
    <CCardBody class='max-w-900'>
      <!-- <div>
      <h3>{{$t("createHotel.hotelInfo")}}</h3>
    </div>
    <div class="card-head d-flex ai-center">
      <div
        class="d-flex align-items-center justify-content-between w-100"
        v-if="hotel.hotelName"
      >
        <div class="mr-10px">
          <h3 v-if="hotel.hotelName" class="text-transform-uppercase">{{hotel.hotelName}}</h3>
        </div>
      </div>
    </div>

    <div class="card-head d-flex ai-center justify-content-between d-flex pt-0px bb-none"></div>
    <div class="row">
      <div class="col-2 d-flex">
        <strong class="c-gray">{{$t("createHotel.hotelInfo")}}</strong>
      </div>

      <div class="col-2 d-flex">
        <strong class="c-gray">{{$t("createHotel.hotelInfo")}}</strong>
      </div>

      <div class="col-2 d-flex">
        <strong class="c-gray">{{$t("createHotel.hotelInfo")}}</strong>
      </div>
      </div>-->
     
      <div class="col-md-12" v-if="hotel">
        <!-- <div class="tickting_details">
          <h2 class="m_title">{{$t("createHotel.hotelInfo")}}</h2>
          <div class="m_content">
            <table>
              <thead>
                <tr>
                  <th>
                    <strong class="c-gray">{{$t("createHotel.hotelName")}}</strong>
                  </th>
                  <th>
                    <strong class="c-gray">{{$t("createHotel.hotelOldName")}}</strong>
                  </th>
                  <th>
                    <strong class="c-gray">{{$t("createHotel.website")}}</strong>
                  </th>
                  <th>
                    <strong class="c-gray"></strong>
                  </th>
                  <th>
                    <strong class="c-gray"></strong>
                  </th>
                  <th>
                    <strong class="c-gray"></strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div v-if="hotel.hotelName">
                      <div>{{hotel.hotelName}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.hotelNameOld">
                      <div>{{hotel.hotelNameOld}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.www">
                      <div>{{hotel.www}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
        <div class="tickting_details mt-2">
          <h5 class="m_title p-1">{{$t("createHotel.addressDetails")}}</h5>
          <div class="m_content p-1">
            <table>
              <thead>
                <tr>
                  <th>
                    <p class="c-gray">{{$t("createHotel.address")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.city")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.country")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.postalCode")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.nearestCities")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.nearestAirport")}}</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div v-if="hotel.address">
                      <div v-html="hotel.address"></div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.cityCode">
                      <div v-if="hotel.cityCode.cityname">{{hotel.cityCode.cityname}}</div>
                       <div v-else>{{hotel.city}}</div>

                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.countryCode">
                      <div v-if="hotel.countryCode.value">{{hotel.countryCode.value}}</div>
                       <div v-else>{{hotel.country}}</div>

                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.postalCode">
                      <div>{{ hotel.postalCode?hotel.postalCode.toString().toUpperCase():''}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.nearestCities">
                      <div>
                        <span
                          v-for="(cityObj,index) in hotel.nearestCities"
                          :key="index"
                        >{{index==0?'':', '}}
                        <span v-if="cityObj&&cityObj.cityname">
                     {{cityObj.cityname}}
                        </span>
                        
                      <span v-else>
              {{cityObj|hmsCityName}}
                      </span>
                        
                        
                        </span>
                        <!-- <span v-for="(cityObj,index) in hotel.nearestCityNames"
                          :key="index+'cityname'">
                          {{cityObj}}{{index==0?'':', '}}
                        </span> -->
                      </div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>

                  <td>
                    <div v-if="hotel.nearestAirports">
                      <div>
                        <span
                          v-for="(airportObj,index) in hotel.nearestAirports"
                          :key="index"
                        >{{index==0?'':', '}}
                        
                        
                         {{airportObj.airportname?airportObj.airportname:getAirportName(airportObj)}}</span>
                      </div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="tickting_details  mt-2">
          <h5 class="m_title  p-1">{{$t("createHotel.contactDetails")}}</h5>
          <div class="m_content  p-1">
            <table>
              <thead>
                <tr>
                  <th>
                    <p class="c-gray">{{$t("createHotel.contactNumber")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.emailId")}}</p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div v-if="hotel.contactNumber">
                      <div>{{hotel.contactNumber}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.contactEmailId">
                      <div>{{hotel.contactEmailId}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="tickting_details  mt-2">
          <h5 class="m_title  p-1">{{$t("createHotel.bankDetails")}}</h5>
          <div class="m_content  p-1">
            <table>
              <thead>
                <tr>
                  <th>
                    <p class="c-gray">{{$t("createHotel.accountHolderName")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.accountNumber")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.bankName")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.branch")}}</p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div v-if="hotel.bankAccountName">
                      <div>{{hotel.bankAccountName}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.bankAccountNumber">
                      <div>{{hotel.bankAccountNumber}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.bankName">
                      <div>{{hotel.bankName}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.bankBranch">
                      <div>{{hotel.bankBranch}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <!-- <td>
                    <div v-if="hotel.ifsc">
                      <div>{{hotel.ifsc}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td> -->
                  <!-- <td>
                    <div v-if="hotel.swiftCode">
                      <div>{{hotel.swiftCode}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>

         <div class="tickting_details  mt-2">
          <h5 class="m_title  p-1">{{$t("createHotel.reservation")}}</h5>
          <div class="m_content  p-1">
            <table>
              <thead>
                <tr>
                  <th>
                    <p class="c-gray">{{$t("createHotel.contactPersonName")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.contactNumber")}}</p>
                  </th>
                  <th>
                    <p class="c-gray">{{$t("createHotel.emailId")}}</p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                  <th>
                    <p class="c-gray"></p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div v-if="hotel.reservationContactName">
                      <div>{{hotel.reservationContactName}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.reservationContactNumber">
                      <div>{{hotel.reservationContactNumber}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                  <td>
                    <div v-if="hotel.reservationEmailId">
                      <div>{{hotel.reservationEmailId}}</div>
                    </div>
                    <div v-else>{{'-'}}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <br>
          <div v-if="isEditOption"
      @click="onEdit" 
    class="generate-ex-btn"
    >
    <p class="hyperlink-c"><label>EDIT</label> </p>
   
 </div>

    </CCardBody>
    </div>
    </CCard>
    
      </CCollapse>
   <cAlertModal
            v-if="isShowAlertModal"
            :key="'hotel'+alertCount"
            :buttonList="modalButton"
            :status="modalStatus"
            :isShowIcon="true"
            :show="isShowAlertModal"
            :desc="confirmTxt"
          ></cAlertModal>


           <cAlertModal
            v-if="showErrAlert"
            :key="'hotel'+'err'"
            :buttonList="getErrAlertModalBtns()"
            :status="2"
            :isShowIcon="true"
            :show="showErrAlert"
            :desc="$t('createHotel.errDesc')"
          ></cAlertModal>
</div>

    
</template>
<script>
import { COMPONENT_NAME, PATHNAME, ALERT_MODAL_STATUS, HOTEL_INFO_TAB_IDS } from '../../util/constants';
import BaseConfiguration from '../../config/base';
import Logger from '../../services/logger';
import { LOG_TYPE,FILE_NAME } from '../../config/API_DATA';
import { navigate } from '../../router';
import  cStatusButton  from '../../components/form/cStatusButton'
import apiUpdateHotel from "../../services/apiUpdateHotel.js";
import apiGetAirports from '../../services/apiGetAirports'
import apiGetCitiesforHotel from '../../services/apiGetCitiesforHotel'
import { cloneDeep, getErrorAlertValue, handleJWT } from '../../util/util';
import { getErrorMessage, VALIDATE_SUCCESS_RES } from '../../util/apiValidate';
import cAlertModal from "../../components/form/cAlertModal";
import cHotelSelection from '../../components/hms/manage/hotelInfo/cHotelSelection'
import{mapGetters,mapActions} from 'vuex'

import TheHeaderDropdownAccnt from "../../containers/TheHeaderDropdownAccnt";
import apiGetHotelInfo from "../../services/apiGetHotelInfo";
import apiGetHotelErrors from "../../services/apiGetHotelErrors"
import cHotelThumbnail from './manage/hotelInfo/cHotelThumbnail'
export default {
  name:COMPONENT_NAME.C_REVIEW_HOTEL,
  components:{
    cStatusButton,
    cAlertModal,
    cHotelSelection,
    cHotelThumbnail,
    TheHeaderDropdownAccnt
  },
  props: {
    hotelObj: {
      type: Object,
      default: null
    },
     isToggleOption: {
      type: Boolean,
      default: false
    },
    isEditOption: {
      type: Boolean,
      default: false
    },
    isShowLeftPart:{
      type:Boolean,
      default:false
    },
    isHideDetails:{
      type:Boolean,
      default:true
    },
    isNeedStatusBtn:{
      type:Boolean,
      default:true
    },
    toShowDp:{
      type:Boolean,
      default:false
    }
    
  },
   data: () => {
    return {
         isHmsFlow: BaseConfiguration.isHmsFlow,
      collapse: true,
      hotel:null,
      isShowAlertModal: false,
      showErrAlert:false,
      showStatus:true,
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      confirmTxt: null,
      alertValue:null
    };
  },

  computed:{
  ...mapGetters('sHotelSearch',{lsAirports:'GET_AIRPORTS_LIST'}),
      ...mapGetters("sHotelSearch", {
      routeObj: "GET_HOTEL_ROUTES_OBJ",
    }),
      ...mapGetters("shmsManage", {
      GET_ALL_ENUMS:"GET_ALL_ENUMS",
      HOTEL_ERROR_TYPE: "GET_HOTEL_ERROR_TYPE",
      HOTEL_ERROR_CATEGORY: "GET_HOTEL_ERROR_CATEGORY",
      
    }),
    
  
  },
  async created(){
        if(BaseConfiguration.isDebug) console.log("created");
         this.hotel=this.hotelObj;
    
        this.collapse=!this.isHideDetails;


              if (!this.routeObj) {
        await this.setRoutesResponse();
      }
        if(!this.lsAirports)
        {
               let airportsRes = await  this.getAllAirports()

               if(airportsRes)
               {
                this.SET_AIRPORTS_LIST(airportsRes)

               }
        }
       

  },
  methods: {

       ...mapActions("sHotelSearch", {
      SET_HOTEL_ROUTES_OBJ: "SET_HOTEL_ROUTES_OBJ",
    }),
  ...mapActions('sHotelSearch',{SET_AIRPORTS_LIST:'SET_AIRPORTS_LIST'}),
    
    emitSelHotelObj(pSelHotel){
      this.$emit('getSelHotelObj',pSelHotel)
    },


        toggleErrAlert() {
            try {
              if(BaseConfiguration.isDebug) console.log("toggleErrAlert");
            this.showErrAlert = !this.showErrAlert;

            } catch (err) {
                    let body = Logger.buildRequest(
                      COMPONENT_NAME.C_REVIEW_HOTEL,
                      "error in toggleErrAlert",
                      err.toString(),
                      "toggleErrAlert",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
            
            }, 


            getErrAlertModalBtns() {
               let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("getErrAlertModalBtns");
                   retValue=[
                     {
                       name: this.$t('createHotel.okBtn'),
                       func:this.onUpdateErr

                     },
                    
                   ]
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_REVIEW_HOTEL,
                          "error in getErrAlertModalBtns",
                          err.toString(),
                          "getErrAlertModalBtns",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
                }, 




    getAirportName(pAirportCode) {
         let retValue='';
        try {
          if(BaseConfiguration.isDebug) console.log("getAirportName");

          if(pAirportCode)
          {

            if(this.lsAirports && this.lsAirports.length)
           retValue= this.lsAirports.find(airport=> airport.airportcode==pAirportCode).airportname
          }
          else
          {
            throw 'invalid Airport code'
          }
       
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_REVIEW_HOTEL,
                  "error in getAirportName",
                  err.toString(),
                  "getAirportName",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 





  async setRoutesResponse() {
      try {
        if (BaseConfiguration.isDebug) console.log("setRoutesResponse");

        let routesRequest = apiGetCitiesforHotel.buildRequest();

        if (routesRequest) {
          // this.SET_AGENCY_REQ(routesRequest); //save req in store
          let routeResponse = await apiGetCitiesforHotel.getResponse(
            routesRequest
          );

          if (VALIDATE_SUCCESS_RES(routeResponse)) {
            // this.SET_AGENCY_RES(setRoutesResponse); //save res in store
            let response = routeResponse.data.data;
            this.SET_HOTEL_ROUTES_OBJ(response);
          } else {
            let error = getErrorMessage(routeResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.C_REVIEW_HOTEL,
          "error while getting response from get Routes response API",
          err.toString(),
          "setRoutesResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

        async getAllAirports() {
      let airportList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAllAirports");
        let airportRequest = apiGetAirports.buildRequest();

        if (airportRequest) {
          let airportResponse = await apiGetAirports.getResponse(
            airportRequest
          );

          if (VALIDATE_SUCCESS_RES(airportResponse)) {
          
            airportList = airportResponse.data.data;
          } else {
            let error = getErrorMessage(airportResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
             getErrorAlertValue(error);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
        COMPONENT_NAME.C_REVIEW_HOTEL,
          "error in getAllAirports",
          err.toString(),
          "getAllAirports",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return airportList;
    },

    toggleCollapse(){
      if(this.isToggleOption) {
        this.collapse = !this.collapse;
      }
    },

          async getHotelInfo() {
      let retValue
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelInfo");
        if (this.hotelObj) {
        let hotelInfoRequest = apiGetHotelInfo.buildRequest(this.hotelObj.hotelid);

        if (hotelInfoRequest) {
          let hotelInfoResponse = await apiGetHotelInfo.getResponse(
            hotelInfoRequest
          );

          if (VALIDATE_SUCCESS_RES(hotelInfoResponse)) {
            this.alertValue = null;
            retValue = hotelInfoResponse.data.data.info;
            retValue.mainImageUrl=hotelInfoResponse.data.data.mainImageUrl
            retValue["country"] = 
                         this.$options.filters.hmsCountryName(retValue.countryCode);
                          retValue["city"]= 
                         this.$options.filters.hmsCityName(retValue.cityCode);
          //                retValue["nearestCityNames"] = []
          // retValue.nearestCities.forEach(cities => {
          //   retValue.nearestCityNames.push(this.$options.filters.hmsCityName(cities))
          // });
          } else {
            let error = getErrorMessage(hotelInfoResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        }
        }
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.C_REVIEW_HOTEL,
          "error in getHotelInfo",
          err.toString(),
          "getHotelInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
        async onUpdateHotel() {
      try {
        if (BaseConfiguration.isDebug) console.log("onUpdateHotel");

        if (this.hotel) {
          let hotelRequest = this.getUpdateHotelRequest(this.hotel);
          if (hotelRequest) {
           

            let retHotelRes = await this.updateHotel(hotelRequest);

            if (retHotelRes) {
              let hotelInfoObj = await this.getHotelInfo();
              this.hotel=hotelInfoObj;
              // this.hotel=retHotelRes;
              this.showAlertModal(
                ALERT_MODAL_STATUS.SUCCESS,
                this.$t("createHotel.statusUpdateSuccDesc")
              );
            } else {
            this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
            }
          } else {
            throw "invalid request";
          }
        }
      
      } catch (err) {
        let body = Logger.buildRequest(
         COMPONENT_NAME.C_REVIEW_HOTEL,
          "error in onUpdateHotel",
          err.toString(),
          "onUpdateHotel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
        async updateHotel(pHotelReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateHotel");
        let hotelReq = apiUpdateHotel.buildRequest(pHotelReq);

        if (hotelReq) {
          let hotelRes = await apiUpdateHotel.getResponse(
            hotelReq
          );

          if (VALIDATE_SUCCESS_RES(hotelRes)) {
            this.alertValue = null;
            retValue = hotelRes.data.data;
          } else {
            let error = getErrorMessage(hotelRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REVIEW_HOTEL,
          "error in updateHotel",
          err.toString(),
          "updateHotel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
       onConfirmStatusChange() {
      try {
        if (BaseConfiguration.isDebug) console.log("onConfirmStatusChange");
        if (this.hotelObj) {
          this.showAlertModal(
            ALERT_MODAL_STATUS.INFO,
            this.$t("createHotel.updateHotelConfirmation")
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REVIEW_HOTEL,
          "error in onConfirmStatusChange",
          err.toString(),
          "onConfirmStatusChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
     toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
      // this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },
    showAlertModal(status, val) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;
      this.confirmTxt = val;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("createHotel.noBtn"),
            func: this.toggleShowAlertModal
          },
          {
            name: this.$t("createHotel.yesBtn"),
            func: this.onUpdateHotel
          }
        ];
      } else if (
        status == ALERT_MODAL_STATUS.SUCCESS 
      ) {
        this.modalButton = [
          {
            name: this.$t("createHotel.okBtn"),
            func: this.toggleShowAlertModal
          }
        ];
      }else if(status==ALERT_MODAL_STATUS.FAIL){
        this.modalButton = [
          {
            name: this.$t("createHotel.okBtn"),
            func: this.toggleShowAlertModal
          }
        ];
      }
    },
    async getHotelErrors() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelErrors");

        if (this.hotelObj) {
          let hotelErrorsReq = apiGetHotelErrors.buildRequest(
            this.hotelObj.hotelid
          );

          if (hotelErrorsReq) {
            let hotelErrorsRes = await apiGetHotelErrors.getResponse(
              hotelErrorsReq
            );

            if (VALIDATE_SUCCESS_RES(hotelErrorsRes)) {
              retValue = hotelErrorsRes.data.data
                ? hotelErrorsRes.data.data.list
                : [];
            } else {
              let error = getErrorMessage(hotelErrorsRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                getErrorAlertValue(error);
              }
            }
          }
        } else {
          throw "invalid hotel obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REVIEW_HOTEL,
          "error in getHotelErrors",
          err.toString(),
          "getHotelErrors",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
     onUpdateErr() {
         try {
           if(BaseConfiguration.isDebug) console.log("onUpdateErr");
           this.$emit('onUpdateErr',HOTEL_INFO_TAB_IDS.ERROR)

             this.showStatus=true
           this.toggleErrAlert()
     
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.C_REVIEW_HOTEL,
                   "error in onUpdateErr",
                   err.toString(),
                   "onUpdateErr",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           
         }, 



     async getErrCount() {
          let retValue=0;
           try {
             if(BaseConfiguration.isDebug) console.log("getErrCount");


              let    lsHotelErrors  =await this.getHotelErrors()
                

          if(lsHotelErrors && lsHotelErrors.length)
          {
            retValue=lsHotelErrors.filter(err=>err.type==this.HOTEL_ERROR_TYPE.Error).length
          }
            
       
           } catch (err) {
                   let body = Logger.buildRequest(
                     COMPONENT_NAME.C_REVIEW_HOTEL,
                     "error in getErrCount",
                     err.toString(),
                     "getErrCount",
                     LOG_TYPE.ERROR
                   );
                   Logger.getResponse(body);
                 }
             return retValue;
           }, 


     async   onChangeHotelStatus() {
        try {
          if(BaseConfiguration.isDebug) console.log("onChangeHotelStatus");


          
         
          let errCount=0
    

                if(!this.hotel.isActive)   
                {
                       errCount = await this.getErrCount()
                }

        

         if(errCount)
         {
          this.toggleErrAlert()

          this.showStatus=false
         }
         else
         {
       
         this.hotel.isActive=!this.hotel.isActive
         

         this.onUpdateHotel();
         }
        } catch (err) {
                let body = Logger.buildRequest(
                 COMPONENT_NAME.C_REVIEW_HOTEL,
                  "error in onChangeHotelStatus",
                  err.toString(),
                  "onChangeHotelStatus",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
         getUpdateHotelRequest(pHotelObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getUpdateHotelRequest");
        let starRating;
         for(var i in this.GET_ALL_ENUMS.hotelStarRating){
           pHotelObj.starRating = parseFloat(pHotelObj.starRating);
          if(pHotelObj.starRating == this.GET_ALL_ENUMS.hotelStarRating[i]){
            starRating = {code:i,name:this.GET_ALL_ENUMS.hotelStarRating[i]}
            
          }
            
        }
        retValue = {
          contactText: pHotelObj.contactText?pHotelObj.contactText:null,
          bankText: pHotelObj.bankText?pHotelObj.bankText:null,
          reservationText: pHotelObj.reservationText?pHotelObj.reservationText:null,
          salesText: pHotelObj.salesText?pHotelObj.salesText:null,
          hotelName: pHotelObj.hotelName,
          salesEmailId: pHotelObj.salesEmailId,
          salesContactNumber: pHotelObj.salesContactNumber?pHotelObj.salesContactNumber:null,
          salesDesignation: pHotelObj.salesDesignation?pHotelObj.salesDesignation.code:null,
          salesPersonName: pHotelObj.salesPersonName,
          reservationEmailId: pHotelObj.reservationEmailId,
          reservationContactNumber: pHotelObj.reservationContactNumber?pHotelObj.reservationContactNumber:null,
          reservationContactName: pHotelObj.reservationContactName,
          bankBranch: pHotelObj.bankBranch,
          bankName: pHotelObj.bankName,
          bankAccountNumber: pHotelObj.bankAccountNumber,
          bankAccountName: pHotelObj.bankAccountName,
          contactEmailId: pHotelObj.contactEmailId,
          contactNumber: pHotelObj.contactNumber,
          nearestAirports: pHotelObj.nearestAirports,
          nearestCities: pHotelObj.nearestCities,
          postalCode: pHotelObj.postalCode,
          // postalCode: pHotelObj.postalCode.toString().toUpperCase(),
           cityCode: pHotelObj.cityCode,
          countryCode: pHotelObj.countryCode,
          address: pHotelObj.address,
          description: pHotelObj.description,
          www: pHotelObj.www,
          starRating: starRating.code.toString(),
          hotelNameOld: pHotelObj.hotelNameOld,
          supplierGroup: pHotelObj.supplierGroup.id,
          isActive: pHotelObj.isActive,
          hotelId: pHotelObj.hotelid,
          currency: pHotelObj.currency
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_REVIEW_HOTEL,
          "error in getUpdateHotelRequest",
          err.toString(),
          "getUpdateHotelRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    onEdit() {
        try {
          if(BaseConfiguration.isDebug) console.log("onEdit");
         navigate(PATHNAME.MANAGE_HOTEL_NEW)
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_REVIEW_HOTEL,
                  "error in onEdit",
                  err.toString(),
                  "onEdit",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
  

}
};
</script>












<style>
.activeText {
  color: #03A9F4;
}
.card.header-bg{
  background-color: #0a1e40;          
}
.post-content {  
    /* opacity: 0.5;     */
    position: absolute;
    top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);  
}
.post-content.responsive{
  top: 20% !important; 
}
.thumbnail{
    position:relative;
    
}
</style>